(() => {
  const root = document.querySelector('[data-sbf-cookie-banner]');
  if (!root || root.dataset.sbfCookieReady) return;
  root.dataset.sbfCookieReady = '2026-09-10';

  const summary = root.querySelector('[data-sbf-cookie-summary]');
  const preferences = root.querySelector('[data-sbf-cookie-preferences]');
  const accept = root.querySelector('[data-sbf-cookie-accept]');
  const reject = root.querySelector('[data-sbf-cookie-reject]');
  const save = root.querySelector('[data-sbf-cookie-save]');
  const status = root.querySelector('[data-sbf-cookie-status]');
  const preferenceTitle = root.querySelector('[data-sbf-cookie-preferences-title]');
  const choices = [...root.querySelectorAll('[data-sbf-cookie-choice]')];
  const buttons = [accept, reject, save].filter(Boolean);
  const labels = buttons.map((button) => button.textContent);
  const keys = ['analytics', 'marketing', 'preferences'];
  const storageKey = 'sbf_cookie_pending_v1';
  const forcePreview = new URLSearchParams(window.location.search).get('sbf_cookie_preview') === '1';
  const valid = (record) => record?.version === 1 && Number.isFinite(record.expiresAt) && record.expiresAt > Date.now() && Number.isFinite(record.createdAt) && keys.every((key) => typeof record.consent?.[key] === 'boolean');
  const readPending = () => {
    try {
      const record = JSON.parse(window.localStorage.getItem(storageKey));
      return valid(record) ? { version: 1, createdAt: record.createdAt, expiresAt: record.expiresAt, consent: Object.fromEntries(keys.map((key) => [key, record.consent[key]])) } : null;
    } catch (_) { return null; }
  };
  const remember = (record) => {
    try {
      const value = JSON.stringify(record);
      window.localStorage.setItem(storageKey, value);
      return window.localStorage.getItem(storageKey) === value;
    } catch (_) { return false; }
  };
  const privacy = () => window.Shopify?.customerPrivacy;
  const current = () => {
    try { return privacy()?.currentVisitorConsent?.() || {}; }
    catch (_) { return {}; }
  };
  const matches = (record) => {
    const consent = current();
    return keys.every((key) => consent[key] === (record.consent[key] ? 'yes' : 'no'));
  };
  const hide = () => { root.hidden = true; };
  const setView = (view) => {
    summary.hidden = view === 'preferences';
    preferences.hidden = view !== 'preferences';
    if (view === 'preferences') preferenceTitle?.focus?.();
  };
  const message = (text) => {
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !text;
  };
  const busy = (value, clicked) => {
    root.setAttribute('aria-busy', String(value));
    buttons.forEach((button, index) => {
      button.disabled = value;
      button.textContent = value && button === clicked ? root.dataset.sbfCookieSaving : labels[index];
    });
  };

  let pending = readPending();
  let remembered = Boolean(pending);
  let inFlight = false;
  let retries = 0;
  let retryTimer;
  let watchTimer;
  let initTimer;
  let loadRequested = false;
  let loadAttempts = 0;
  let initAttempts = 0;
  let request = 0;
  let clickedThisPage = false;

  const finish = (record) => {
    if (pending !== record) return;
    window.clearTimeout(watchTimer);
    window.clearTimeout(retryTimer);
    try {
      const stored = readPending();
      if (stored?.createdAt === record.createdAt && keys.every((key) => stored.consent[key] === record.consent[key])) window.localStorage.removeItem(storageKey);
    } catch (_) {}
    pending = null;
    inFlight = false;
    busy(false);
    message('');
    hide();
  };

  const failed = (record, serial) => {
    if (pending !== record || serial !== request) return;
    window.clearTimeout(watchTimer);
    inFlight = false;
    if (matches(record)) return finish(record);
    if (retries < 3) {
      const delay = [500, 1500, 4000][retries++];
      retryTimer = window.setTimeout(sync, delay);
    } else if (!remembered) {
      busy(false);
      message(root.dataset.sbfCookieError);
      root.hidden = false;
    }
  };

  function sync() {
    if (!pending || inFlight) return;
    const record = pending;
    if (matches(record)) return finish(record);
    if (typeof privacy()?.setTrackingConsent !== 'function') return;
    inFlight = true;
    const serial = ++request;
    watchTimer = window.setTimeout(() => failed(record, serial), 5000);
    try {
      privacy().setTrackingConsent(record.consent, (result) => {
        if (pending !== record || serial !== request) return;
        if (!result?.error && matches(record)) finish(record);
        else failed(record, serial);
      });
      if (pending === record && matches(record)) finish(record);
    } catch (_) { failed(record, serial); }
  }

  const initialise = () => {
    window.clearTimeout(initTimer);
    const api = privacy();
    if (typeof api?.setTrackingConsent === 'function' && typeof api?.currentVisitorConsent === 'function') {
      const consent = current();
      choices.forEach((input) => { input.checked = pending ? pending.consent[input.dataset.sbfCookieChoice] : consent[input.dataset.sbfCookieChoice] === 'yes'; });
      if (pending) {
        if (remembered) hide();
        sync();
      } else if (!clickedThisPage) {
        root.hidden = !forcePreview && keys.every((key) => consent[key] === 'yes' || consent[key] === 'no');
      }
      return;
    }
    if (!loadRequested && loadAttempts < 3 && typeof window.Shopify?.loadFeatures === 'function') {
      loadRequested = true;
      loadAttempts += 1;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          loadRequested = false;
          if (!error && typeof privacy()?.setTrackingConsent === 'function') initialise();
        });
      } catch (_) { loadRequested = false; }
    }
    if (pending && remembered) hide();
    else if (initAttempts >= 3 && !clickedThisPage) root.hidden = false;
    if (++initAttempts <= 60) initTimer = window.setTimeout(initialise, 500);
    else if (pending && !remembered) {
      busy(false);
      message(root.dataset.sbfCookieError);
    }
  };

  const saveConsent = (consent, button) => {
    if (inFlight) return;
    clickedThisPage = true;
    const now = Date.now();
    pending = { version: 1, createdAt: now, expiresAt: now + 86400000, consent };
    remembered = remember(pending);
    retries = 0;
    initAttempts = 0;
    window.clearTimeout(retryTimer);
    busy(true, button);
    message('');
    if (remembered) hide();
    initialise();
  };

  root.querySelector('[data-sbf-cookie-choose]')?.addEventListener('click', () => setView('preferences'));
  root.querySelector('[data-sbf-cookie-back]')?.addEventListener('click', () => setView('summary'));
  accept?.addEventListener('click', () => saveConsent({ analytics: true, marketing: true, preferences: true }, accept));
  reject?.addEventListener('click', () => saveConsent({ analytics: false, marketing: false, preferences: false }, reject));
  save?.addEventListener('click', () => saveConsent(Object.fromEntries(choices.map((input) => [input.dataset.sbfCookieChoice, input.checked])), save));
  const resume = () => {
    if (pending) { retries = 0; initAttempts = 0; loadAttempts = 0; }
    initialise();
  };
  window.addEventListener('online', resume);
  window.addEventListener('pageshow', resume);
  document.addEventListener('visitorConsentCollected', () => {
    if (pending && matches(pending)) finish(pending);
  });
  setView('summary');
  initialise();
})();
